/* tslint:disable */
/* eslint-disable */
/**
 * Web IMD-CONNECT.PRO
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { DamageCase } from '../models';
// @ts-ignore
import { PDFTypes } from '../models';
// @ts-ignore
import { Payment } from '../models';
// @ts-ignore
import { PaymentReceipt } from '../models';
// @ts-ignore
import { PdfDamagecasesTypeTempSavePost200Response } from '../models';
/**
 * PaymentApi - axios parameter creator
 * @export
 */
export const PaymentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get payment for damagecase
         * @param {number} damageCaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damageCaseDamageCaseIdDamageCasePaymentGet: async (damageCaseId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'damageCaseId' is not null or undefined
            assertParamExists('damageCaseDamageCaseIdDamageCasePaymentGet', 'damageCaseId', damageCaseId)
            const localVarPath = `/damageCase/{damageCaseId}/damageCasePayment`
                .replace(`{${"damageCaseId"}}`, encodeURIComponent(String(damageCaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a specific payment
         * @param {number} damageCasePaymentId 
         * @param {Payment} [payment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damageCasePaymentDamageCasePaymentIdPut: async (damageCasePaymentId: number, payment?: Payment, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'damageCasePaymentId' is not null or undefined
            assertParamExists('damageCasePaymentDamageCasePaymentIdPut', 'damageCasePaymentId', damageCasePaymentId)
            const localVarPath = `/damageCasePayment/{damageCasePaymentId}`
                .replace(`{${"damageCasePaymentId"}}`, encodeURIComponent(String(damageCasePaymentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(payment, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Store a specific payment receipt
         * @param {number} damageCasePayment 
         * @param {PaymentReceipt} [paymentReceipt] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damageCasePaymentDamageCasePaymentReceiptsBatchPost: async (damageCasePayment: number, paymentReceipt?: PaymentReceipt, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'damageCasePayment' is not null or undefined
            assertParamExists('damageCasePaymentDamageCasePaymentReceiptsBatchPost', 'damageCasePayment', damageCasePayment)
            const localVarPath = `/damageCasePayment/{damageCasePayment}/receipts/batch`
                .replace(`{${"damageCasePayment"}}`, encodeURIComponent(String(damageCasePayment)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(paymentReceipt, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a specific payment receipt
         * @param {number} damageCasePayment 
         * @param {PaymentReceipt} [paymentReceipt] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damageCasePaymentDamageCasePaymentReceiptsBatchPut: async (damageCasePayment: number, paymentReceipt?: PaymentReceipt, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'damageCasePayment' is not null or undefined
            assertParamExists('damageCasePaymentDamageCasePaymentReceiptsBatchPut', 'damageCasePayment', damageCasePayment)
            const localVarPath = `/damageCasePayment/{damageCasePayment}/receipts/batch`
                .replace(`{${"damageCasePayment"}}`, encodeURIComponent(String(damageCasePayment)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(paymentReceipt, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete the payment receipt by ID
         * @param {number} id 
         * @param {number} damageCasePayment 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damageCasePaymentDamageCasePaymentReceiptsIdDelete: async (id: number, damageCasePayment: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('damageCasePaymentDamageCasePaymentReceiptsIdDelete', 'id', id)
            // verify required parameter 'damageCasePayment' is not null or undefined
            assertParamExists('damageCasePaymentDamageCasePaymentReceiptsIdDelete', 'damageCasePayment', damageCasePayment)
            const localVarPath = `/damageCasePayment/{damageCasePayment}/receipts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"damageCasePayment"}}`, encodeURIComponent(String(damageCasePayment)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the Payment receipt by ID
         * @param {number} damageCasePayment 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damageCasePaymentDamageCasePaymentReceiptsIdGet: async (damageCasePayment: number, id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'damageCasePayment' is not null or undefined
            assertParamExists('damageCasePaymentDamageCasePaymentReceiptsIdGet', 'damageCasePayment', damageCasePayment)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('damageCasePaymentDamageCasePaymentReceiptsIdGet', 'id', id)
            const localVarPath = `/damageCasePayment/{damageCasePayment}/receipts/{id}`
                .replace(`{${"damageCasePayment"}}`, encodeURIComponent(String(damageCasePayment)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a specific payment receipt
         * @param {number} id 
         * @param {number} damageCasePayment 
         * @param {PaymentReceipt} [paymentReceipt] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damageCasePaymentDamageCasePaymentReceiptsIdPut: async (id: number, damageCasePayment: number, paymentReceipt?: PaymentReceipt, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('damageCasePaymentDamageCasePaymentReceiptsIdPut', 'id', id)
            // verify required parameter 'damageCasePayment' is not null or undefined
            assertParamExists('damageCasePaymentDamageCasePaymentReceiptsIdPut', 'damageCasePayment', damageCasePayment)
            const localVarPath = `/damageCasePayment/{damageCasePayment}/receipts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"damageCasePayment"}}`, encodeURIComponent(String(damageCasePayment)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(paymentReceipt, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get text for dunning
         * @param {number} damageCaseId 
         * @param {string} type 
         * @param {string} deadline 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damageCasePaymentDunningtextDamageCaseIdTypeDeadlineGet: async (damageCaseId: number, type: string, deadline: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'damageCaseId' is not null or undefined
            assertParamExists('damageCasePaymentDunningtextDamageCaseIdTypeDeadlineGet', 'damageCaseId', damageCaseId)
            // verify required parameter 'type' is not null or undefined
            assertParamExists('damageCasePaymentDunningtextDamageCaseIdTypeDeadlineGet', 'type', type)
            // verify required parameter 'deadline' is not null or undefined
            assertParamExists('damageCasePaymentDunningtextDamageCaseIdTypeDeadlineGet', 'deadline', deadline)
            const localVarPath = `/damageCasePayment/dunningtext/{damageCaseId}/{type}/{deadline}`
                .replace(`{${"damageCaseId"}}`, encodeURIComponent(String(damageCaseId)))
                .replace(`{${"type"}}`, encodeURIComponent(String(type)))
                .replace(`{${"deadline"}}`, encodeURIComponent(String(deadline)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sent E-Mail to context-Lawyer
         * @param {number} damageCaseId 
         * @param {Payment} payment 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damageCasePaymentEmailDamageCaseIdPost: async (damageCaseId: number, payment: Payment, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'damageCaseId' is not null or undefined
            assertParamExists('damageCasePaymentEmailDamageCaseIdPost', 'damageCaseId', damageCaseId)
            // verify required parameter 'payment' is not null or undefined
            assertParamExists('damageCasePaymentEmailDamageCaseIdPost', 'payment', payment)
            const localVarPath = `/damageCasePayment/email/{damageCaseId}`
                .replace(`{${"damageCaseId"}}`, encodeURIComponent(String(damageCaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(payment, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the uuid of the temporary file
         * @param {PDFTypes} type 
         * @param {DamageCase} [damageCase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfDamagecasesTypeTempSavePost: async (type: PDFTypes, damageCase?: DamageCase, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'type' is not null or undefined
            assertParamExists('pdfDamagecasesTypeTempSavePost', 'type', type)
            const localVarPath = `/pdf/damagecases/{type}/temp/save`
                .replace(`{${"type"}}`, encodeURIComponent(String(type)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication cookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(damageCase, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PaymentApi - functional programming interface
 * @export
 */
export const PaymentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PaymentApiAxiosParamCreator(configuration)
    return {
        /**
         * Get payment for damagecase
         * @param {number} damageCaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damageCaseDamageCaseIdDamageCasePaymentGet(damageCaseId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Payment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damageCaseDamageCaseIdDamageCasePaymentGet(damageCaseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update a specific payment
         * @param {number} damageCasePaymentId 
         * @param {Payment} [payment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damageCasePaymentDamageCasePaymentIdPut(damageCasePaymentId: number, payment?: Payment, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Payment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damageCasePaymentDamageCasePaymentIdPut(damageCasePaymentId, payment, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Store a specific payment receipt
         * @param {number} damageCasePayment 
         * @param {PaymentReceipt} [paymentReceipt] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damageCasePaymentDamageCasePaymentReceiptsBatchPost(damageCasePayment: number, paymentReceipt?: PaymentReceipt, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentReceipt>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damageCasePaymentDamageCasePaymentReceiptsBatchPost(damageCasePayment, paymentReceipt, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update a specific payment receipt
         * @param {number} damageCasePayment 
         * @param {PaymentReceipt} [paymentReceipt] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damageCasePaymentDamageCasePaymentReceiptsBatchPut(damageCasePayment: number, paymentReceipt?: PaymentReceipt, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentReceipt>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damageCasePaymentDamageCasePaymentReceiptsBatchPut(damageCasePayment, paymentReceipt, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Delete the payment receipt by ID
         * @param {number} id 
         * @param {number} damageCasePayment 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damageCasePaymentDamageCasePaymentReceiptsIdDelete(id: number, damageCasePayment: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damageCasePaymentDamageCasePaymentReceiptsIdDelete(id, damageCasePayment, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get the Payment receipt by ID
         * @param {number} damageCasePayment 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damageCasePaymentDamageCasePaymentReceiptsIdGet(damageCasePayment: number, id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentReceipt>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damageCasePaymentDamageCasePaymentReceiptsIdGet(damageCasePayment, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Update a specific payment receipt
         * @param {number} id 
         * @param {number} damageCasePayment 
         * @param {PaymentReceipt} [paymentReceipt] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damageCasePaymentDamageCasePaymentReceiptsIdPut(id: number, damageCasePayment: number, paymentReceipt?: PaymentReceipt, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentReceipt>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damageCasePaymentDamageCasePaymentReceiptsIdPut(id, damageCasePayment, paymentReceipt, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get text for dunning
         * @param {number} damageCaseId 
         * @param {string} type 
         * @param {string} deadline 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damageCasePaymentDunningtextDamageCaseIdTypeDeadlineGet(damageCaseId: number, type: string, deadline: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Payment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damageCasePaymentDunningtextDamageCaseIdTypeDeadlineGet(damageCaseId, type, deadline, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Sent E-Mail to context-Lawyer
         * @param {number} damageCaseId 
         * @param {Payment} payment 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async damageCasePaymentEmailDamageCaseIdPost(damageCaseId: number, payment: Payment, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Payment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.damageCasePaymentEmailDamageCaseIdPost(damageCaseId, payment, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get the uuid of the temporary file
         * @param {PDFTypes} type 
         * @param {DamageCase} [damageCase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pdfDamagecasesTypeTempSavePost(type: PDFTypes, damageCase?: DamageCase, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PdfDamagecasesTypeTempSavePost200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pdfDamagecasesTypeTempSavePost(type, damageCase, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PaymentApi - factory interface
 * @export
 */
export const PaymentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PaymentApiFp(configuration)
    return {
        /**
         * Get payment for damagecase
         * @param {number} damageCaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damageCaseDamageCaseIdDamageCasePaymentGet(damageCaseId: number, options?: any): AxiosPromise<Payment> {
            return localVarFp.damageCaseDamageCaseIdDamageCasePaymentGet(damageCaseId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a specific payment
         * @param {number} damageCasePaymentId 
         * @param {Payment} [payment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damageCasePaymentDamageCasePaymentIdPut(damageCasePaymentId: number, payment?: Payment, options?: any): AxiosPromise<Payment> {
            return localVarFp.damageCasePaymentDamageCasePaymentIdPut(damageCasePaymentId, payment, options).then((request) => request(axios, basePath));
        },
        /**
         * Store a specific payment receipt
         * @param {number} damageCasePayment 
         * @param {PaymentReceipt} [paymentReceipt] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damageCasePaymentDamageCasePaymentReceiptsBatchPost(damageCasePayment: number, paymentReceipt?: PaymentReceipt, options?: any): AxiosPromise<PaymentReceipt> {
            return localVarFp.damageCasePaymentDamageCasePaymentReceiptsBatchPost(damageCasePayment, paymentReceipt, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a specific payment receipt
         * @param {number} damageCasePayment 
         * @param {PaymentReceipt} [paymentReceipt] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damageCasePaymentDamageCasePaymentReceiptsBatchPut(damageCasePayment: number, paymentReceipt?: PaymentReceipt, options?: any): AxiosPromise<PaymentReceipt> {
            return localVarFp.damageCasePaymentDamageCasePaymentReceiptsBatchPut(damageCasePayment, paymentReceipt, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete the payment receipt by ID
         * @param {number} id 
         * @param {number} damageCasePayment 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damageCasePaymentDamageCasePaymentReceiptsIdDelete(id: number, damageCasePayment: number, options?: any): AxiosPromise<void> {
            return localVarFp.damageCasePaymentDamageCasePaymentReceiptsIdDelete(id, damageCasePayment, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the Payment receipt by ID
         * @param {number} damageCasePayment 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damageCasePaymentDamageCasePaymentReceiptsIdGet(damageCasePayment: number, id: number, options?: any): AxiosPromise<PaymentReceipt> {
            return localVarFp.damageCasePaymentDamageCasePaymentReceiptsIdGet(damageCasePayment, id, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a specific payment receipt
         * @param {number} id 
         * @param {number} damageCasePayment 
         * @param {PaymentReceipt} [paymentReceipt] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damageCasePaymentDamageCasePaymentReceiptsIdPut(id: number, damageCasePayment: number, paymentReceipt?: PaymentReceipt, options?: any): AxiosPromise<PaymentReceipt> {
            return localVarFp.damageCasePaymentDamageCasePaymentReceiptsIdPut(id, damageCasePayment, paymentReceipt, options).then((request) => request(axios, basePath));
        },
        /**
         * Get text for dunning
         * @param {number} damageCaseId 
         * @param {string} type 
         * @param {string} deadline 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damageCasePaymentDunningtextDamageCaseIdTypeDeadlineGet(damageCaseId: number, type: string, deadline: string, options?: any): AxiosPromise<Payment> {
            return localVarFp.damageCasePaymentDunningtextDamageCaseIdTypeDeadlineGet(damageCaseId, type, deadline, options).then((request) => request(axios, basePath));
        },
        /**
         * Sent E-Mail to context-Lawyer
         * @param {number} damageCaseId 
         * @param {Payment} payment 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        damageCasePaymentEmailDamageCaseIdPost(damageCaseId: number, payment: Payment, options?: any): AxiosPromise<Payment> {
            return localVarFp.damageCasePaymentEmailDamageCaseIdPost(damageCaseId, payment, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the uuid of the temporary file
         * @param {PDFTypes} type 
         * @param {DamageCase} [damageCase] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pdfDamagecasesTypeTempSavePost(type: PDFTypes, damageCase?: DamageCase, options?: any): AxiosPromise<PdfDamagecasesTypeTempSavePost200Response> {
            return localVarFp.pdfDamagecasesTypeTempSavePost(type, damageCase, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PaymentApi - object-oriented interface
 * @export
 * @class PaymentApi
 * @extends {BaseAPI}
 */
export class PaymentApi extends BaseAPI {
    /**
     * Get payment for damagecase
     * @param {number} damageCaseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentApi
     */
    public damageCaseDamageCaseIdDamageCasePaymentGet(damageCaseId: number, options?: AxiosRequestConfig) {
        return PaymentApiFp(this.configuration).damageCaseDamageCaseIdDamageCasePaymentGet(damageCaseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a specific payment
     * @param {number} damageCasePaymentId 
     * @param {Payment} [payment] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentApi
     */
    public damageCasePaymentDamageCasePaymentIdPut(damageCasePaymentId: number, payment?: Payment, options?: AxiosRequestConfig) {
        return PaymentApiFp(this.configuration).damageCasePaymentDamageCasePaymentIdPut(damageCasePaymentId, payment, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Store a specific payment receipt
     * @param {number} damageCasePayment 
     * @param {PaymentReceipt} [paymentReceipt] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentApi
     */
    public damageCasePaymentDamageCasePaymentReceiptsBatchPost(damageCasePayment: number, paymentReceipt?: PaymentReceipt, options?: AxiosRequestConfig) {
        return PaymentApiFp(this.configuration).damageCasePaymentDamageCasePaymentReceiptsBatchPost(damageCasePayment, paymentReceipt, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a specific payment receipt
     * @param {number} damageCasePayment 
     * @param {PaymentReceipt} [paymentReceipt] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentApi
     */
    public damageCasePaymentDamageCasePaymentReceiptsBatchPut(damageCasePayment: number, paymentReceipt?: PaymentReceipt, options?: AxiosRequestConfig) {
        return PaymentApiFp(this.configuration).damageCasePaymentDamageCasePaymentReceiptsBatchPut(damageCasePayment, paymentReceipt, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete the payment receipt by ID
     * @param {number} id 
     * @param {number} damageCasePayment 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentApi
     */
    public damageCasePaymentDamageCasePaymentReceiptsIdDelete(id: number, damageCasePayment: number, options?: AxiosRequestConfig) {
        return PaymentApiFp(this.configuration).damageCasePaymentDamageCasePaymentReceiptsIdDelete(id, damageCasePayment, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the Payment receipt by ID
     * @param {number} damageCasePayment 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentApi
     */
    public damageCasePaymentDamageCasePaymentReceiptsIdGet(damageCasePayment: number, id: number, options?: AxiosRequestConfig) {
        return PaymentApiFp(this.configuration).damageCasePaymentDamageCasePaymentReceiptsIdGet(damageCasePayment, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a specific payment receipt
     * @param {number} id 
     * @param {number} damageCasePayment 
     * @param {PaymentReceipt} [paymentReceipt] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentApi
     */
    public damageCasePaymentDamageCasePaymentReceiptsIdPut(id: number, damageCasePayment: number, paymentReceipt?: PaymentReceipt, options?: AxiosRequestConfig) {
        return PaymentApiFp(this.configuration).damageCasePaymentDamageCasePaymentReceiptsIdPut(id, damageCasePayment, paymentReceipt, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get text for dunning
     * @param {number} damageCaseId 
     * @param {string} type 
     * @param {string} deadline 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentApi
     */
    public damageCasePaymentDunningtextDamageCaseIdTypeDeadlineGet(damageCaseId: number, type: string, deadline: string, options?: AxiosRequestConfig) {
        return PaymentApiFp(this.configuration).damageCasePaymentDunningtextDamageCaseIdTypeDeadlineGet(damageCaseId, type, deadline, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sent E-Mail to context-Lawyer
     * @param {number} damageCaseId 
     * @param {Payment} payment 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentApi
     */
    public damageCasePaymentEmailDamageCaseIdPost(damageCaseId: number, payment: Payment, options?: AxiosRequestConfig) {
        return PaymentApiFp(this.configuration).damageCasePaymentEmailDamageCaseIdPost(damageCaseId, payment, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the uuid of the temporary file
     * @param {PDFTypes} type 
     * @param {DamageCase} [damageCase] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentApi
     */
    public pdfDamagecasesTypeTempSavePost(type: PDFTypes, damageCase?: DamageCase, options?: AxiosRequestConfig) {
        return PaymentApiFp(this.configuration).pdfDamagecasesTypeTempSavePost(type, damageCase, options).then((request) => request(this.axios, this.basePath));
    }
}
